import Immutable from "immutable";
import React from "react";
import useFormComponentState from "../../../../common/forms/useFormComponentState";
import { SearchCriterion } from "../common/SearchCriterion";
import { createDatePicker, createYearPicker, getInputRange } from "./inputs";
import { Range } from "./Range";
import { rangeCreateControlType, requiredRolesType } from "../../../../common/types/search/search";
import { visibilitySelectorType } from "../../../../common/types/common";
import { RangeFieldsPassedProps } from "./RangeFields";

interface RangeCriterionProps extends RangeFieldsPassedProps {
	createControl?: rangeCreateControlType;
	criterionKey: string;
	label: string;
	prefix?: string;
	quickSearch?: boolean;
	requiredRoles?: requiredRolesType;
	visibilitySelector?: visibilitySelectorType;
}

export const RANGE_CRITERION_INITIAL_STATE = Immutable.Map();

export function RangeCriterion({
	createControl,
	criterionKey,
	label,
	prefix,
	quickSearch = false,
	requiredRoles,
	visibilitySelector,
	...props
}: RangeCriterionProps) {
	const { currentInput, onInputChange, onClearInput } = useFormComponentState(
		criterionKey,
		RANGE_CRITERION_INITIAL_STATE,
	);

	const datesRange = createControl === createDatePicker;
	const yearsRange = createControl === createYearPicker;
	const inputMin = currentInput.get("min", "");
	const inputMax = currentInput.get("max", "");
	const inputRange = getInputRange(inputMin, inputMax, datesRange);

	return (
		<SearchCriterion
			label={label}
			prefix={prefix}
			quickSearch={quickSearch}
			requiredRoles={requiredRoles}
			visibilitySelector={visibilitySelector}
		>
			<Range
				createControl={createControl}
				criterionKey={criterionKey}
				currentInput={currentInput}
				datesRange={datesRange}
				label={label}
				inputMax={inputMax}
				inputMin={inputMin}
				inputRange={inputRange}
				onClearInput={onClearInput}
				onInputChange={onInputChange}
				prefix={prefix}
				quickSearch={quickSearch}
				yearsRange={yearsRange}
				{...props}
			/>
		</SearchCriterion>
	);
}
